import cn from "classnames";
import { Button } from "src/components/Button";
import { ReactComponent as PhoneIcon } from "src/assets/icons/phone.svg";
import { useActiveSection } from "./HashObserver";
import { SECTION_IDS } from "./constants";
import { ButtonVariants } from "src/components/Button/types";
import { useGetContactsQuery } from "src/redux/api";

const formatPhoneForTel = (phone: string): string => {
  const cleaned = phone.replace(/\D/g, "");
  return cleaned.startsWith("38") ? `+${cleaned}` : `+38${cleaned}`;
};

export const ContactUsScrollButton = () => {
  const activeSection = useActiveSection();
  const isVisible = SECTION_IDS.CONTACT_US !== activeSection;
  const { data: contacts } = useGetContactsQuery();

  const handleClick = () => {
    if (contacts?.phone) {
      window.location.href = `tel:${formatPhoneForTel(contacts.phone)}`;
    }
  };

  return (
    <Button
      variant={ButtonVariants.GREEN}
      className={cn(
        "fixed bottom-4 right-4 w-15 h-15 z-10 rounded-full duration-300 md:right-8",
        {
          "opacity-100 translate-y-0 scale-100": isVisible,
          "opacity-0 translate-y-20 scale-50": !isVisible,
        }
      )}
      onClick={handleClick}
    >
      <PhoneIcon />
    </Button>
  );
};
